import { DropdownMenuItem } from '@/components/ui/DropdownMenu'
import {
  DocumentMagnifyingGlassIcon,
  XMarkIcon,
} from '@heroicons/react/16/solid'
import React, { useState } from 'react'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Separator } from '@radix-ui/react-separator'
import { Button } from '@/components/ui/button'
// import MoneyPathsTable from './MoneyPathsTable'
import { Link } from 'react-router-dom'
import useCloseToOrigin from '@/hooks/useCloseToOrigin'
import MyTodosTable from './MyTodosTable'
import { FeatureGate } from '@/components/feature-gate'

export default function MyTodosModal({ open, setOpen }) {
  const closeToOrigin = useCloseToOrigin()
  return (
    <>
      <Dialog open={true} onOpenChange={() => closeToOrigin()} defaultOpen={true}>
        <DialogContent className="max-h-[37.5rem] min-h-[15rem] md:max-w-5xl ">
          <DialogHeader>
            <DialogTitle>My Todos</DialogTitle>
            <DialogClose>
              <XMarkIcon />
            </DialogClose>
          </DialogHeader>

          <Separator />
          <DialogBody className="flex flex-col gap-4">
            <FeatureGate feature="to-do" mode="block">
              <MyTodosTable />
            </FeatureGate>
          </DialogBody>
          <Separator />
          <DialogFooter>
            <Button
              type="button"
              variant="secondary"
              onClick={() => closeToOrigin()}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
